import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RenderableMenu } from '@layout-lib';
import { combineLatest, concat, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'era-menus',
  templateUrl: './menus.component.html',
  styleUrls: ['./menus.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, AsyncPipe],
})
export class MenusComponent {
  @Input() menus: RenderableMenu[];

  public isActiveOrLastMatched$(menu: RenderableMenu): Observable<boolean> {
    const hasChildren$ = concat(of(null), menu.children$.pipe(map((children) => children && children.length > 0)));

    return combineLatest([hasChildren$, menu.isMatched$, menu.isActive$]).pipe(
      map(([hasChildren, isMatched, isActive]) => isMatched || (!hasChildren && isActive))
    );
  }
}
